import React from 'react';
import { useVendor } from 'contexts/vendor.context';
import { getFrontendPortalUrl } from 'services/config.service';

function Footer() {
  const { vendor } = useVendor();

  return (
    <footer id="footer" className="footer dark-background">
      <div className="container footer-top">
        <div className="row gy-4">
          <div className="col-lg-4 col-md-6 footer-about">
            <a href="/" className="logo d-flex align-items-center">
              <span className="sitename">{vendor?.company_name}</span>
            </a>
            <div className="footer-contact pt-3">
              <p>{vendor?.company_address}</p>
              <p>State- {vendor?.state}, {vendor?.country}-{vendor?.pincode}</p>
              <p className="mt-3"><strong>Phone:</strong> <span>{vendor?.company_phone}</span></p>
              <p><strong>Landline:</strong> <span>{vendor?.company_landline}</span></p>
              <p><strong>Email:</strong> <span>{vendor?.company_email}</span></p>
            </div>
            <div className="social-links d-flex mt-4">
              <a href="/"><i className="bi bi-twitter-x"></i></a>
              <a href="/"><i className="bi bi-facebook"></i></a>
              <a href="/"><i className="bi bi-instagram"></i></a>
              <a href="/"><i className="bi bi-linkedin"></i></a>
            </div>
          </div>

          <div className="col-lg-2 col-md-3 footer-links">
            <h4>Useful Links</h4>
            <ul>
              <li><a href="/">Home</a></li>
              <li><a href={`${getFrontendPortalUrl()}/#/verify-email?action=post-a-job`}>Post a Job</a></li>
              <li><a href={`${getFrontendPortalUrl()}/#/verify-email?action=upload-cv`}>Upload CV</a></li>
              <li><a href="/terms-of-service">Terms of service</a></li>
              <li><a href="/privacy-policy">Privacy policy</a></li>
            </ul>
          </div>

          <div className="col-lg-4 col-md-12 footer-newsletter">
            <h4>Our Newsletter</h4>
            <p>Subscribe to our newsletter and receive the latest news about our products and services!</p>
            <form onSubmit={(e) => e.preventDefault()} className="php-email-form">
              <div className="newsletter-form">
                <input type="email" name="email" />
                <input type="submit" value="Subscribe" />
              </div>
              {/* <div className="loading">Loading</div>
              <div className="error-message"></div>
              <div className="sent-message">Your subscription request has been sent. Thank you!</div> */}
            </form>
          </div>
        </div>
      </div>

      <div className="container copyright text-center mt-4">
        <p>
          © {new Date().getFullYear()} <span>Copyright</span> <strong className="px-1 sitename">SailorsData</strong> <span>All Rights Reserved</span>
        </p>
      </div>
    </footer>
  );
}

export default Footer;
